import React, { useState, useEffect } from 'react';

const locations = [
  { name: 'Pune', videoUrl: 'https://www.youtube.com/embed/your-pune-video-id' },
  { name: 'PCMC', videoUrl: 'https://www.youtube.com/embed/your-pcmc-video-id' },
  { name: 'Mumbai', videoUrl: 'https://www.youtube.com/embed/your-mumbai-video-id' },
  { name: 'Satara', videoUrl: 'https://www.youtube.com/embed/your-satara-video-id' },
];

const AreasWeServe = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = width <= 768;
  const isTablet = width > 768 && width <= 1024;

  return (
    <div style={{
      padding: isMobile ? '40px 10px' : '60px 20px',
      background: '#f8f8f8',
      fontFamily: 'Outfit, sans-serif',
      textAlign: 'center',
    }}>
      <h2 style={{
        fontSize: isMobile ? '26px' : isTablet ? '32px' : '36px',
        fontWeight: '900',
        marginBottom: '20px',
        color: '#111'
      }}>
        Areas We Serve
      </h2>
      <p style={{
        fontSize: isMobile ? '16px' : '18px',
        marginBottom: '40px',
        color: '#555'
      }}>
        Serving Clients Across Maharashtra
      </p>

      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px',
        justifyContent: 'center',
        maxWidth: '1000px',
        margin: '0 auto'
      }}>
        {locations.map((loc, index) => (
          <button
            key={index}
            onClick={() => setSelectedVideo(loc.videoUrl)}
            style={{
              background: '#202d34',
              color: '#fff',
              padding: isMobile ? '14px 20px' : '18px 28px',
              borderRadius: '12px',
              border: 'none',
              boxShadow: '0 8px 20px rgba(30,136,229,0.3)',
              cursor: 'pointer',
              fontSize: isMobile ? '16px' : '18px',
              fontWeight: '600',
              minWidth: isMobile ? '140px' : '180px',
              transition: 'all 0.3s ease-in-out',
            }}
            onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
          >
            {loc.name}
          </button>
        ))}
      </div>

      {/* Modal */}
      {selectedVideo && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.85)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}
          onClick={() => setSelectedVideo(null)}
        >
          <div style={{ width: '90%', maxWidth: '800px', position: 'relative' }}>
            <iframe
              width="100%"
              height={isMobile ? '240' : isTablet ? '360' : '450'}
              src={selectedVideo}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="Virtual Office Tour"
              style={{ borderRadius: '12px' }}
            ></iframe>
            <button
              onClick={() => setSelectedVideo(null)}
              style={{
                position: 'absolute',
                top: 10,
                right: 10,
                background: '#fff',
                color: '#000',
                border: 'none',
                padding: '6px 12px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: '600'
              }}
            >
              ✕ Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AreasWeServe;
